/**
 * package: com.inq.stage
 * class: ViewportMgr
 *
 * viewportMgr is class controls display in Mobile devices
 * Two very important facts are; viewport meta tag and viewport as visible area's location and size of a client page.
 *
 *
 * root Object
 * @constructor
 */
com.inq.stage.ViewportMgr = function() {

};
/* Register this base class to $hxClasses object. */
$hxClasses.registerClass(com.inq.stage.ViewportMgr ,'com.inq.stage.ViewportMgr');

/** @const */
com.inq.stage.ViewportMgr.VIEWPORT_ID = "tcChat_viewport";

/** @private @type {com.inq.stage.IViewportMgr} */
com.inq.stage.ViewportMgr.impl = null;

/**
 * init
 *
 * set com.inq.stage.ViewportMgr.impl when it is null
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.ViewportMgr.init = function() {
	if (com.inq.stage.ViewportMgr.impl == null) {
		com.inq.stage.ViewportMgr.impl = com.inq.stage.ViewportMgr.getImplementation();
	}
};


/**
 * close
 *
 * call hide() and remove impl
 *
 * @public
 * @static
 * @return {void}
 */
 com.inq.stage.ViewportMgr.close = function() {
	 if (com.inq.stage.ViewportMgr.impl != null) {
		 com.inq.stage.ViewportMgr.hide();
	 }
	com.inq.stage.ViewportMgr.impl = null;
};


/**
 * visible
 *
 * Calls show() or hide() according to _vis value
 *
 * @public
 * @static
 * @param {boolean}  _vis
 * @return {void}
 */
com.inq.stage.ViewportMgr.visible = function(_vis) {
	if(_vis) com.inq.stage.ViewportMgr.show();
	else com.inq.stage.ViewportMgr.hide();
};


/**
 * show
 *
 * call impl's show() function.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.ViewportMgr.show = function() {
	if ( com.inq.flash.client.control.MinimizeManager.isMinimized() ) {
		return;
	}

	if (com.inq.stage.ViewportMgr.impl == null)	com.inq.stage.ViewportMgr.init();
	com.inq.stage.ViewportMgr.impl && com.inq.stage.ViewportMgr.impl.show();

	/* RTDEV-10837 On iOS 9, viewport.resizeChat() should be called again,
	   because window.innerWidth is changed as shrink-to-fit at not expected time and causing racing condition.
	   If the resizeChat() is executed with delay, scroll is broken on parent page.
	 */
	if ((com.inq.utils.Capabilities.isSafariVersion9()
		|| com.inq.utils.Capabilities.isSafariVersion10()
		|| com.inq.utils.Capabilities.isSafariVersion11()
		|| com.inq.utils.Capabilities.isSafariVersion12()
		|| com.inq.utils.Capabilities.isSafariVersion13()
		|| com.inq.utils.Capabilities.isSafariVersion14orLater()
		|| com.inq.utils.Capabilities.getUserAgent().toLowerCase().indexOf("crios") > -1)

		&& com.inq.utils.Capabilities.isPhone()

		&& (typeof com.inq.flash.client.chatskins.ChatTextFocusMonitor.closing !== "undefined"
			&& com.inq.flash.client.chatskins.ChatTextFocusMonitor.closing === false)

		&& !com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			com.inq.utils.Timer.delay($bind(com.inq.stage.ViewportMgr.impl, com.inq.stage.ViewportMgr.impl.resizeChat), 50);
		}
};


/**
 * hide
 *
 * call impl's hide() function.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.ViewportMgr.hide = function() {
	if (com.inq.stage.ViewportMgr.impl == null)	com.inq.stage.ViewportMgr.init();
	com.inq.stage.ViewportMgr.impl && com.inq.stage.ViewportMgr.impl.hide();
};


/**
 * uponResize
 *
 * call impl's uponResize() function.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.ViewportMgr.uponResize = function() {
	if (com.inq.stage.ViewportMgr.impl == null)	com.inq.stage.ViewportMgr.init();
	com.inq.stage.ViewportMgr.impl && com.inq.stage.ViewportMgr.impl.uponResize();
};


/**
 * getChatZoomLevel
 *
 * Returns zoom level on phone devices; zoom level is controlled by viewport meta tag.
 *
 * @public
 * @static
 * @return {number}
 */
com.inq.stage.ViewportMgr.getChatZoomLevel = function() {
	com.inq.stage.ViewportMgr.init();
	return com.inq.stage.ViewportMgr.impl.getChatZoomLevel();
};


/**
 * getImplementation
 *
 * Return selected viewport implementation according to device identification.
 *
 * @private
 * @static
 * @return {com.inq.stage.ViewportMgrImpl}
 */
com.inq.stage.ViewportMgr.getImplementation = function() {
	if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		return new com.inq.stage.ViewportMgrImplBase;
	}
	if(com.inq.utils.Capabilities.isPhone()) {
		if (com.inq.utils.Capabilities.isWindowsPhone()) {
			return new com.inq.stage.ViewportMgrImplPhoneWindows();
		}
		else if(com.inq.utils.Capabilities.isAndroid()) {
			if(com.inq.utils.Capabilities.isAndroid("Android 2")) 
				return new com.inq.stage.ViewportMgrImplPhoneAndroid_2();
			else 
				return new com.inq.stage.ViewportMgrImplPhoneAndroid();
		}
		return new com.inq.stage.ViewportMgrImplPhone();
	} else if(com.inq.utils.Capabilities.isTablet()) {
		return new com.inq.stage.ViewportMgrImplTablet();
	} else {
		return new com.inq.stage.ViewportMgrImplBase();
	}
};

/** @type {com.inq.stage.ViewportMgr} */
com.inq.stage.ViewportMgr.prototype.__class__ = com.inq.stage.ViewportMgr;


